import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useMutation, useQuery } from "@tanstack/react-query";
import { deleteAxios, getAxios } from "../../shared/Services/commonService";
import { API_SESSION } from "../../utils/api/ApiConstant";
import { Loading } from "../../shared/Components";
import Icon from "../../assets/icons/Icon";
import { queryClient } from "../../utils/queryClientUtil";
import { clearStorage } from "../../store/user/user-action";

const getDeviceIcon = (userAgent = "") => {
  const ua = userAgent.toLowerCase();

  if (
    ua.includes("mobile") ||
    ua.includes("android") ||
    ua.includes("iphone")
  ) {
    return "Smartphone";
  }
  if (ua.includes("mac")) return "Monitor";
  if (ua.includes("windows")) return "Laptop";

  return "Monitor";
};

const getBrowser = (userAgent = "") => {
  if (userAgent.includes("Chrome")) return "Chrome";
  if (userAgent.includes("Firefox")) return "Firefox";
  if (userAgent.includes("Safari")) return "Safari";
  if (userAgent.includes("Edge")) return "Edge";

  return "Unknown Browser";
};

const getOS = (userAgent = "") => {
  if (userAgent.includes("Windows")) return "Windows";
  if (userAgent.includes("Mac")) return "MacOS";
  if (userAgent.includes("Linux")) return "Linux";
  if (userAgent.includes("Android")) return "Android";
  if (userAgent.includes("iPhone")) return "iPhone";

  return "Unknown OS";
};

const formatDate = (date) => {
  return new Date(date).toLocaleString("en-IN", {
    dateStyle: "medium",
    timeStyle: "short",
  });
};

const ActiveSessions = () => {
  const [isEndAllHovered, setIsEndAllHovered] = useState(false);

  const LoggedInUserUniqueIdentity = useSelector(
    (state) => state.user?.sessionDetails?.uniqueIdentity,
  );

  const { data, isLoading } = useQuery({
    queryKey: ["activeSessionList", LoggedInUserUniqueIdentity],
    queryFn: async () => {
      const res = await getAxios(API_SESSION);
      return res;
    },
    enabled: !!LoggedInUserUniqueIdentity,
  });

  const sessions = Array.isArray(data)
    ? [...data].sort(
        (a, b) =>
          (b?.uniqueIdentity === LoggedInUserUniqueIdentity) -
          (a?.uniqueIdentity === LoggedInUserUniqueIdentity),
      )
    : [];

  const logoutMutation = useMutation({
    mutationFn: async (id) => {
      return deleteAxios(`${API_SESSION}/${id}`, false);
    },

    // REMOVE IMMEDIATELY
    onMutate: async (id) => {
      queryClient.setQueryData(
        ["activeSessionList", LoggedInUserUniqueIdentity],
        (oldData = []) => {
          return oldData.filter((session) => session.id !== id);
        },
      );
    },
  });

  const handleSesionLogout = async (session = {}) => {
    const id = session?.id;

    if (!id) {
      await deleteAxios(`${API_SESSION}/all`, {}, false);
      clearStorage();
    } else {
      logoutMutation.mutate(id);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <>
      <div className="Sessions_model">
        <div className="Sessions_model-sub">
          Hover over any session, then click to end it.
        </div>

        {sessions && sessions.length >= 2 ? (
          <button
            className="end_btn"
            onClick={() => handleSesionLogout({})}
            onMouseEnter={() => setIsEndAllHovered(true)}
            onMouseLeave={() => setIsEndAllHovered(false)}
          >
            {isEndAllHovered ? "Click to End All Sessions" : "End All Sessions"}
          </button>
        ) : (
          <></>
        )}

        <div className="list">
          {sessions && sessions.length > 0 ? (
            sessions.map((session, i) => {
              const isCurrent =
                session?.uniqueIdentity === LoggedInUserUniqueIdentity;

              const iconName = getDeviceIcon(session?.userAgent);

              return (
                <div
                  className={`session ${isCurrent ? "current" : ""}`}
                  key={i}
                >
                  <div className="session-left">
                    <div className="icon-box">
                      <Icon name={iconName} size={15} />
                    </div>
                    <div className="info">
                      <div className="device">
                        {getBrowser(session?.userAgent)} on{" "}
                        {getOS(session?.userAgent)}
                        {isCurrent && (
                          <span className="current-badge">Current</span>
                        )}
                      </div>
                      <div className="details">
                        <span>{session?.ipAddress}</span>
                        <span>
                          Last active: {formatDate(session?.loginTime)}
                        </span>
                      </div>
                    </div>
                  </div>
                  {isCurrent ? (
                    <span className="active-now"></span>
                  ) : (
                    <div className="overlay" onclick="endSession(event, this)">
                      <div className="overlay-icon">
                        <svg
                          width="18"
                          height="18"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2.5"
                        >
                          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
                        </svg>
                      </div>
                      <div
                        className="overlay-content"
                        onClick={() => handleSesionLogout(session)}
                      >
                        <span className="overlay-text">
                          Click me to end this session
                        </span>
                        {/* <span className="overlay-hint">
                          <span className="click-icon">
                            <svg
                              width="8"
                              height="8"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              stroke-width="3"
                            >
                              <path d="M12 19V5M5 12l7-7 7 7" />
                            </svg>
                          </span>
                          Click anywhere to confirm
                        </span> */}
                      </div>
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <>No Record</>
          )}
        </div>
      </div>
    </>
  );
};

export default ActiveSessions;
